import { render, staticRenderFns } from "./VisitCallVvrtc.vue?vue&type=template&id=1064a8e0&scoped=true&"
import script from "./VisitCallVvrtc.vue?vue&type=script&lang=js&"
export * from "./VisitCallVvrtc.vue?vue&type=script&lang=js&"
import style0 from "./VisitCallVvrtc.vue?vue&type=style&index=0&id=1064a8e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064a8e0",
  null
  
)

export default component.exports